module.exports = __webpack_public_path__ + "static/media/linkedin.49a4b8d1.svg";